import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/catch";
import {
  errorConsultandoSolicitud,
  errorConsultandoTiposSolicitud,
  solicitudConsultada,
  tiposSolicitudConsultados
} from "./actions";
import {catchError, map, mergeMap} from "rxjs/operators";
import * as types from "./types";
import {ofType} from "redux-observable";
import {RequestWrapper} from "../../../request/RequestWrapper/RequestWrapper";

export const consultarSolicitudEpic = action$ =>
  action$.pipe(
    ofType(types.CONSULTAR_SOLICITUD),
    mergeMap((payload: any) => RequestWrapper
      .secureGet(
        // tslint:disable-next-line:prefer-template
        "/gestion-contenido-empresarial/api/recepcion-documental/solicitud/"
        + payload.body.tipoSolicitud + "/"
        + payload.body.idSolicitud + "/"
        + payload.body.identificacion.tipo + "/"
        + payload.body.identificacion.numero,
        payload.body
      )
      .pipe(map(response => solicitudConsultada(response)),
        catchError(error => [errorConsultandoSolicitud(error)]),
      )
    )
  );

export const consultarTiposSolicitudEpic = action$ =>
  action$.pipe(
    ofType(types.CONSULTAR_TIPOS_SOLICITUD),
    mergeMap(() =>
      RequestWrapper
        .get("/gestion-contenido-empresarial/api/recepcion-documental/tipos-solicitud")
        .pipe(map(response => tiposSolicitudConsultados(response)),
          catchError(error => [errorConsultandoTiposSolicitud(error)]),
        )
      )
    );
